<template lang="pug">
  .font-size-controls
    button.font-btn(@click="setFontSize('small')", :class="{ active: fontSize === 'small' }") A-
    button.font-btn(@click="setFontSize('medium')", :class="{ active: fontSize === 'medium' }") A
    button.font-btn(@click="setFontSize('large')", :class="{ active: fontSize === 'large' }") A+
</template>


<script>
export default {
  name: "FontSizeControls",
  data() {
    return {
      fontSize: 'medium',
    }
  },
  mounted() {
    // const savedFont = localStorage.getItem('fontSize')
    // this.setFontSize(savedFont || 'medium')
    this.setFontSize('medium')
  },
  methods: {
    setFontSize(size) {
      this.fontSize = size
      localStorage.setItem('fontSize', size)
      document.body.classList.remove('font-small', 'font-medium', 'font-large')
      document.body.classList.add(`font-${size}`)
    }
  }
}
</script>

<style scoped lang="scss">
.font-size-controls {
  position: fixed;
  bottom: 17vw;
  right: 15px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  z-index: 8;
  
  .font-btn {
    line-height: 1;
    width: 40px;
    height: 40px;
    font-size: 16px;
    // font-weight: bold;
    background: white;
    border: 1px solid #ccc;
    cursor: pointer;
    border-radius: 4px;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    outline: 0;

    &.active {
      background: #005bac;
      color: white;
      border-color: #005bac;
    }
  }
}
@media (max-width: 768px) {
  .font-size-controls {
    bottom: 42vw;
  }
  .font-size-controls .font-btn {
    width: 30px;
    height: 30px;
  }
}
</style>
